import { render, staticRenderFns } from "./BaseInfo_qy.vue?vue&type=template&id=c9c7e296"
import script from "./BaseInfo_qy.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInfo_qy.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports